import * as types from 'Redux/types/downloads';

import yup from 'yup';
import { requestOptions } from 'Helpers/Graphql';

import downloadPackageMutation from 'Gql/mutations/download.photosPackage.mutation';
import downloadPackageQuery from 'Gql/queries/photos.downloadPacakge.query';

export const addPhotos = (photos, creditPackage) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({ type: types.ADD_PHOTOS, requestData: { photos: photos, creditPackage: creditPackage } });
        resolve(true);
    });
};

export const downloadPackageRequest = photos => (dispatch) => {
    let params = {
        ...params,
        photos: photos,
        photoIds: photos.map(photo => photo.id)
    };

    return requestOptions({
        req: null,
        type: types.PACKAGE_REQUEST,
        onRetry: downloadPackageRequest,
        name: 'downloadPackage',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                download: yup.object().shape({
                    downloadPhotosPackage: yup.object().required()
                }).required()
            }).required()
        }),
        params: params,
        requestParams: {
            photoIds: params.photoIds
        },
        query: downloadPackageMutation
            .replace('%name%', 'downloadPackage')
    });
};

export const downloadPackage = packageId => (dispatch) => {
    let params = {
        ...params,
        packageId: packageId
    };

    return requestOptions({
        req: null,
        type: types.PACKAGE,
        onRetry: downloadPackage,
        name: 'downloadPackage',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                me: yup.object().shape({
                    download: yup.object().required()
                }).required()
            }).required()
        }),
        params: params,
        requestParams: {
            id: params.packageId
        },
        query: downloadPackageQuery
            .replace('%name%', 'downloadPackage')
    });
};



// WEBPACK FOOTER //
// ./src/redux/actions/downloads.js